import layoutTypes from './layout.types';

export const INITIAL_STATE = {
  isSideMenuCollapsed: false,
  isSecondMenuCollapsed: true,
  secondMenuKey: null,
};

const layoutReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case layoutTypes.SET_SIDE_MENU_COLLAPSE:
      return {
        ...state,
        isSideMenuCollapsed: action.payload,
      };

    case layoutTypes.SET_SECOND_MENU_COLLAPSE:
      return {
        ...state,
        isSecondMenuCollapsed: action.payload,
        secondMenuKey: !!action.payload ? null : state.secondMenuKey,
      };

    case layoutTypes.SET_SECOND_MENU_KEY:
      return {
        ...state,
        secondMenuKey: action.payload,
      };

    default:
      return state;
  }
};

export default layoutReducer;
